import * as React from "react";

import { cn } from "@/lib/utils";

type EyebrowProps = {
  children: React.ReactNode;
  tone?:
    | "default"
    | "dark"
    | "purple"
    | "green"
    | "rose"
    | "yellow"
    | "blue"
    | "white";
  uppercase?: boolean;
  className?: string;
};

export function Eyebrow({
  children,
  tone = "default",
  uppercase = true,
  className,
}: EyebrowProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-2 rounded-pill border-[1.5px] px-4 py-2 text-eyebrow",
        uppercase && "uppercase",
        {
          "border-clarus-dark bg-clarus-purple text-clarus-dark":
            tone === "default",
          "border-white bg-white/10 text-white": tone === "dark",
          "border-clarus-dark bg-clarus-purple/50 text-clarus-dark":
            tone === "purple",
          "border-clarus-dark bg-clarus-green text-clarus-dark":
            tone === "green",
          "border-clarus-dark bg-clarus-rose text-clarus-dark":
            tone === "rose",
          "border-clarus-dark bg-clarus-yellow text-clarus-dark":
            tone === "yellow",
          "border-clarus-dark bg-clarus-blue text-clarus-dark":
            tone === "blue",
          "border-clarus-dark bg-white text-clarus-dark": tone === "white",
        },
        className,
      )}
    >
      <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-clarus-dark" />
      {children}
    </span>
  );
}
